import { render, staticRenderFns } from "./PDFList.vue?vue&type=template&id=53903160"
import script from "./PDFList.vue?vue&type=script&lang=ts"
export * from "./PDFList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports